<section class="student-ai-timeline" [attr.aria-label]="student() ? 'AI timeline for ' + student()!.fullName : 'AI timeline'">
  <!-- Left: view buttons and AI summary (purple block) -->
  <aside class="student-ai-timeline__rail">
    <!-- <nav class="student-ai-timeline__views" aria-label="Student views">
      <span class="student-ai-timeline__view student-ai-timeline__view--active" aria-current="page">AI Timeline</span>
      <button type="button" class="student-ai-timeline__view" (click)="openStudentView()">Student View</button>
    </nav> -->

    <section class="student-ai-timeline__summary" [attr.aria-labelledby]="uid + '-summary'">
      <h3 class="student-ai-timeline__panel-title" [id]="uid + '-summary'">AI Summary</h3>
      @switch (loadState()) {
        @case ('ready') {
          @for (paragraph of summaryParagraphs(); track $index) {
            <p class="student-ai-timeline__summary-text">@for (segment of paragraph.segments; track $index) {@if (segment.isEmphasised) {<strong class="student-ai-timeline__emphasis">{{ segment.text }}</strong>} @else {<span>{{ segment.text }}</span>}}</p>
          } @empty {
            <p class="student-ai-timeline__summary-text student-ai-timeline__muted">No AI summary is available yet.</p>
          }
        }
        @case ('loading') {
          <span class="student-ai-timeline__skeleton student-ai-timeline__skeleton--line" aria-hidden="true"></span>
          <span class="student-ai-timeline__skeleton student-ai-timeline__skeleton--line" aria-hidden="true"></span>
          <span class="student-ai-timeline__skeleton student-ai-timeline__skeleton--line-short" aria-hidden="true"></span>
        }
      }
    </section>
  </aside>

  <!-- Centre: student header and timeline (white block) -->
  <div class="student-ai-timeline__main" [attr.aria-busy]="loadState() === 'loading'">
    @switch (loadState()) {
      @case ('loading') {
        <div class="student-ai-timeline__loading" role="status">
          <span class="student-ai-timeline__sr-only">Loading AI timeline</span>
          <span class="student-ai-timeline__skeleton student-ai-timeline__skeleton--header" aria-hidden="true"></span>
          @for (card of skeletonCards; track card) {
            <span class="student-ai-timeline__skeleton student-ai-timeline__skeleton--card" aria-hidden="true"></span>
          }
        </div>
      }

      @case ('error') {
        <div class="student-ai-timeline__message student-ai-timeline__message--error" role="alert">
          <p class="student-ai-timeline__message-title">The AI timeline could not be loaded.</p>
          <p class="student-ai-timeline__message-text">Please try again.</p>
          <button type="button" class="student-ai-timeline__button" (click)="load()">Try again</button>
        </div>
      }

      @case ('ready') {
        @if (student(); as s) {
          <header class="student-ai-timeline__student">
            <div class="student-ai-timeline__photo">
              @if (s.photoUrl) {
                <img class="student-ai-timeline__photo-img" [src]="s.photoUrl" [alt]="'Photo of ' + s.fullName" />
              } @else {
                <span class="student-ai-timeline__initials" aria-hidden="true">{{ initials() }}</span>
              }
            </div>
            <div class="student-ai-timeline__student-text">
              <h2 class="student-ai-timeline__student-name">{{ s.fullName }}</h2>
              <p class="student-ai-timeline__student-group">{{ s.yearGroup }} - {{ s.className }}</p>
            </div>
          </header>
        }

        @if (selectedInterventionName(); as name) {
          <div class="student-ai-timeline__filter-note" role="status">
            <span>Highlighting events linked to <strong>{{ name }}</strong></span>
            <button type="button" class="student-ai-timeline__link-button" (click)="clearSelection()">Show all</button>
          </div>
        }
<footer class="student-ai-timeline__key">
          <span class="student-ai-timeline__key-title">Severity Key:</span>
          <ul class="student-ai-timeline__key-list">
            @for (item of severityKey; track item.level) {
              <li class="student-ai-timeline__key-item" [attr.data-severity]="item.level">
                <span class="student-ai-timeline__key-dot" aria-hidden="true"></span>{{ item.label }}
              </li>
            }
          </ul>
        </footer>
        <div class="student-ai-timeline__scroll" tabindex="0" [attr.aria-labelledby]="uid + '-events'">
          <h3 class="student-ai-timeline__sr-only" [id]="uid + '-events'">Timeline events, newest first</h3>

          @if (events().length === 0) {
            <div class="student-ai-timeline__message">
              <p class="student-ai-timeline__message-title">No timeline events yet.</p>
              <p class="student-ai-timeline__message-text">New events for this student will appear here.</p>
            </div>
          } @else {
            <ol class="student-ai-timeline__list">
              @for (event of events(); track event.eventId; let odd = $odd) {
                <li
                  class="student-ai-timeline__entry"
                  [class.student-ai-timeline__entry--offset]="!odd"
                  [class.student-ai-timeline__entry--dimmed]="isDimmed(event)"
                  [attr.data-severity]="event.severity"
                >
                  <div class="student-ai-timeline__date">
                    <time class="student-ai-timeline__date-day" [attr.datetime]="event.eventDate">{{ event.eventDate | date: 'd MMM y' }}</time>
                    <span class="student-ai-timeline__date-weekday">{{ event.eventDate | date: 'EEE' }}</span>
                  </div>

                  <div class="student-ai-timeline__axis" aria-hidden="true">
                    <span class="student-ai-timeline__dot"></span>
                  </div>

                  <article class="student-ai-timeline__card">
                    <span class="student-ai-timeline__icon" aria-hidden="true">
                      @switch (event.category) {
                        @case ('attendance') {
                          <svg viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.2" /><path d="M3.5 19c.6-3.2 2.8-5 5.5-5s4.9 1.8 5.5 5" /><circle cx="17" cy="9.5" r="2.4" /><path d="M15.8 14.2c2.4-.3 4.3 1.2 4.8 4.3" /></svg>
                        }
                        @case ('wellbeing') {
                          <svg viewBox="0 0 24 24"><path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.2a4.3 4.3 0 0 1 7.5 2.6C19.5 15.4 12 20 12 20z" /><path d="M7.5 12.5h2.6l1.3-2.3 2 4.3 1.2-2h2" /></svg>
                        }
                        @case ('conduct') {
                          <svg viewBox="0 0 24 24"><path d="M12 4 21 19.5H3z" /><path d="M12 10v4.5M12 17h.01" /></svg>
                        }
                        @case ('homework') {
                          <svg viewBox="0 0 24 24"><path d="m12 3.8 2.5 5.1 5.6.8-4 3.9 1 5.6-5.1-2.7-5 2.7 1-5.6-4.1-3.9 5.6-.8z" /></svg>
                        }
                        @case ('achievement') {
                          <svg viewBox="0 0 24 24"><path d="M8 4h8v5a4 4 0 0 1-8 0z" /><path d="M8 6H5v1.5A3 3 0 0 0 8 10.5M16 6h3v1.5a3 3 0 0 1-3 3M12 13v4M8.5 20h7M10 17h4" /></svg>
                        }
                        @default {
                          <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8" /><path d="M12 11v5M12 8h.01" /></svg>
                        }
                      }
                    </span>

                    <div class="student-ai-timeline__card-body">
                      <h4 class="student-ai-timeline__card-title">{{ event.title }}</h4>
                      <p class="student-ai-timeline__card-date">
                        <svg class="student-ai-timeline__calendar" viewBox="0 0 16 16" aria-hidden="true"><rect x="2.5" y="3.5" width="11" height="10" rx="1.5" /><path d="M2.5 6.5h11M5.5 2v3M10.5 2v3" /></svg>
                        {{ event.eventDate | date: 'd MMM y' }}
                      </p>
                      <p class="student-ai-timeline__card-text">{{ event.description }}</p>
                    </div>

                    <div class="student-ai-timeline__severity">
                      <span class="student-ai-timeline__pill">{{ event.severityLabel }}</span>
                      <span class="student-ai-timeline__score"><span class="student-ai-timeline__sr-only">Severity score </span>{{ event.severityScoreLabel }}</span>
                    </div>
                  </article>
                </li>
              }
            </ol>
          }
        </div>

        
      }
    }
  </div>

  <!-- Right: intervention effectiveness (green block) -->
  <aside class="student-ai-timeline__interventions" [attr.aria-labelledby]="uid + '-interventions'">
    <h3 class="student-ai-timeline__panel-title" [id]="uid + '-interventions'">Intervention Effectiveness</h3>

    @switch (loadState()) {
      @case ('ready') {
        <ul class="student-ai-timeline__intervention-list">
          @for (item of interventions(); track item.interventionId) {
            <li
              class="student-ai-timeline__intervention"
              [class.student-ai-timeline__intervention--selected]="selectedInterventionId() === item.interventionId"
              [class.student-ai-timeline__intervention--dimmed]="selectedInterventionId() !== null && selectedInterventionId() !== item.interventionId"
            >
              @if (item.linkedEventCount > 0) {
                <button
                  type="button"
                  class="student-ai-timeline__intervention-name student-ai-timeline__intervention-name--toggle"
                  [attr.aria-pressed]="selectedInterventionId() === item.interventionId"
                  [attr.aria-label]="item.name + ': highlight ' + item.linkedEventCount + ' linked events'"
                  (click)="toggleIntervention(item.interventionId)"
                >{{ item.name }} –</button>
              } @else {
                <p class="student-ai-timeline__intervention-name">{{ item.name }} –</p>
              }
              <p class="student-ai-timeline__intervention-start">Started {{ item.startDate | date: 'dd/MM/yyyy' }}</p>
              <p class="student-ai-timeline__effectiveness" [attr.data-level]="item.effectiveness">{{ item.effectivenessLabel }}</p>
              <p class="student-ai-timeline__intervention-text">{{ item.commentary }}</p>
            </li>
          } @empty {
            <li class="student-ai-timeline__intervention-text">No interventions recorded.</li>
          }
        </ul>
      }
      @case ('loading') {
        <span class="student-ai-timeline__skeleton student-ai-timeline__skeleton--line" aria-hidden="true"></span>
        <span class="student-ai-timeline__skeleton student-ai-timeline__skeleton--line-short" aria-hidden="true"></span>
      }
    }
  </aside>
</section>
